import OrderStatus from './order-status';
import OrderNumber from './order-number';
import ItemName from './item-name';
import ItemSku from './item-sku';
import ItemOption from './item-option';
import RecipientName from './recipient-name';
import Email from './email';
import Store from './store';
import OrderDate from './order-date';
import { id as orderStatusFilterId } from '../../../filters/options/order-status';
import { id as orderNumberFilterId } from '../../../filters/options/order-number';
import { id as itemNameFilterId } from '../../../filters/options/item-name';
import { id as itemSkuFilterId } from '../../../filters/options/item-sku';
import { id as itemOptionFilterId } from '../../../filters/options/item-option';
import { id as recipientNameFilterId } from '../../../filters/options/recipient-name';
import { id as emailFilterId } from '../../../filters/options/email';
import { id as storeFilterId } from '../../../filters/options/store';
import { id as orderDateFilterId } from '../../../filters/options/order-date';

export default [
  OrderStatus, // If OrderStatus is ever changed to be not the first member of this array, the code to handle prop of shouldSendFocusToInput will need to be added to that component and its children
  Store,
  OrderNumber,
  RecipientName,
  Email,
  ItemName,
  ItemSku,
  ItemOption,
  OrderDate,
];

export const allOrdersAdvancedSearchFilterIds = [
  orderStatusFilterId,
  storeFilterId,
  orderNumberFilterId,
  recipientNameFilterId,
  emailFilterId,
  itemNameFilterId,
  itemSkuFilterId,
  itemOptionFilterId,
  orderDateFilterId,
];
